import { Carousel } from "@similarweb/ui-components";

import { EmptyItem } from "app/pages/activation/components/HomeWithData/ProjectItem/EmptyItem";
import { Item } from "app/pages/activation/components/HomeWithData/ProjectItem/Item";
import { LoaderItem } from "app/pages/activation/components/HomeWithData/ProjectItem/LoaderItem";
import type { CreatePlacement } from "app/pages/activation/services/tracking/home/homepageWithData";
import type { ActivationMetadataItem } from "app/pages/activation/types/api";
import type { IWebsitesFavicons } from "app/services/sitesService/types";

type ItemsSchema = {
    activations: ActivationMetadataItem[];
    isMetadataLoading: boolean;
    onCreate: (place: CreatePlacement) => () => void;
    onActivationClick: (activation: ActivationMetadataItem) => () => void;
    images: IWebsitesFavicons;
    isImagesLoading: boolean;
};

export const Items = ({
    onActivationClick,
    onCreate,
    isMetadataLoading,
    activations,
    images,
    isImagesLoading,
}: ItemsSchema) => {
    if (isMetadataLoading) {
        return <LoaderItem />;
    }

    return (
        <Carousel
            opts={{
                align: "start",
                slidesToScroll: 2,
            }}
        >
            <Carousel.Content
                style={{
                    marginLeft: "-8px",
                }}
            >
                {activations?.length ? (
                    activations.map((activation) => (
                        <Carousel.Item
                            key={activation.id}
                            style={{
                                paddingLeft: "8px",
                            }}
                        >
                            <Item
                                activation={activation}
                                onClick={onActivationClick(activation)}
                                domainIcon={images[activation.primaryDomain]}
                                isIconsLoading={isImagesLoading}
                            />
                        </Carousel.Item>
                    ))
                ) : (
                    <EmptyItem onClick={onCreate("cta")} />
                )}
            </Carousel.Content>

            <Carousel.Previous className="carouselNavBtn" />
            <Carousel.Next className="carouselNavBtn" />
        </Carousel>
    );
};
